// import axiosHelper from "axiosHelper";
import {
  APIUSEROLD,
  API_FAILURE,
  GET_ASSESMENT_MASTER_LISTING,
} from "../../../../config/constants";
import { apiErrors } from "../../../../helper";
import axiosHelper from "../../../../axiosHelper";
export function fetchAssesmentMasterListing(filter, callback) {
  return (dispatch) => {
    const request = axiosHelper.get(`${APIUSEROLD.getAssesmentMasterListing}`, {
      // params: {
      //   EmployeeId: filter?.EmployeeId,
      //   page: filter.current_page,
      //   pageSize: filter.per_page,
      //   SearchText: filter?.sortField?.supplierName,
      //   SortBy: filter?.sortField,
      //   SortOrder: filter.sortOrder,
      //   RequestFromDate: filter.requestFromDate,
      //   RequestToDate: filter.requestFromDate,
      // }, // Assuming filter contains necessary query parameters
    });
    request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_ASSESMENT_MASTER_LISTING,
            payload: {
              data: response.status === 204 ? [] : response?.data,

              filter, // Include filter in payload
            },
          });
          callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
      } else{

        callback(null, error);
      }
        // apiErrors(error);
      });
  };
}
export function updateQuestionSequence(data) {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
         // Log the data being sent
        const response = await axiosHelper.post(APIUSEROLD.updateAssessmentQuestionOrder, data);
 
        if (response.data) {
           // Log the response data
          resolve(response.data);
        }
      } catch (error) {
         // Log the error
        dispatch({ type: 'API_FAILURE' });
        if (error.response.status === 401) {
          apiErrors(error)
      } else{
        
        reject({ IsSuccessful: false, ErrorMessage: error.message });
      }
      }
    });
  };
}
export function getDeletQuestion(id, callback) {
  axiosHelper
    .delete(
      `${APIUSEROLD.getDeleteAssesmentQuestion}?AssessmentQuestionID=${id}`
    )
    .then((response) => {
      if (callback) {
        callback(null, response); // Call the callback with null for the error parameter and the response
      }
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
    } else{

      if (callback) {
        callback(error, null); // Call the callback with the error and null for the response
      }
    }
    });
}
export function getTypeOfCheckGroupID() {
  const request = axiosHelper.get(`${APIUSEROLD.getAllCheckGroupID}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
    } else{

      throw error; // Re-throw the error to the caller
    }
    });
}
export function getCategoryListDataForAssesment() {
  const request = axiosHelper.get(`${APIUSEROLD.getAllCategoryListForAssesment}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
    } else{

      throw error; // Re-throw the error to the caller
    }
     
    });
}

export function AddNewQuestion(data, callback) {
  return (dispatch) => {
    //dispatch({ type: API_REQUEST });
    const request = axiosHelper.post(APIUSEROLD.addNewQuestion, data);
    request
      .then((response) => {
        if (response.data) {
          callback(response?.data);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
      } else{

        callback(error);
      }
        // apiErrors(error)
      });
  };
}

export function getAssesmentQuestionDetailById(id) {
  const request = axiosHelper.get(
    `${APIUSEROLD.getAssesmentDetailByID}?AssessmentQuestionID=${id}`
  );
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
    } else{

      throw error; // Re-throw the error to the caller
    }
    });
}
export function getReviewQuestionsByCategoryId(id) {
  const request = axiosHelper.get(
    `${APIUSEROLD.getAllReviewQuestionsByCategory}?CategoryId=${id}`
  );
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response.data; // Return the response to the caller
    })
    .catch((error) => {
      // apiErrors(error);
      if (error.response.status === 401) {
        apiErrors(error)
    } else{

      throw error; // Re-throw the error to the caller
    }
    });
}

export function saveNewQuestion(data, callback) {
  return (dispatch) => {
    //dispatch({ type: API_REQUEST });
    const request = axiosHelper.post(APIUSEROLD.saveNewQuestionById, data);
    request
      .then((response) => {
        if (response.data) {
          callback(response?.data);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
      } else{
  
        callback(error);
      }
        // apiErrors(error)
      });
  };
}
